module.exports = __webpack_public_path__ + "static/signup-gif-2d9114f2fad3294cc7b4b46703e64c12.gif";